module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Add Address":"Addresse hinzufügen"}}')
  delete Component.options._Ctor
}
